import { CloseConfirm } from '@src/common/components/CloseConfirm';
import type { ReactNode } from 'react';

type Props = {
  onClose: () => void;
  confirm?: () => void;
  closeLabel?: string;
  confirmLabel?: string;
  closeIcon?: ReactNode;
  confirmIcon?: ReactNode;
  confirmDisabled?: boolean;
  confirmLoading?: boolean;
  isSubmitType?: boolean;
};

export const CloseConfirmModalFooter = ({
  onClose,
  confirm,
  closeLabel,
  confirmLabel,
  confirmIcon,
  closeIcon,
  confirmDisabled,
  confirmLoading,
  isSubmitType,
}: Props) => {
  return (
    <CloseConfirm
      onClose={onClose}
      confirm={confirm}
      closeLabel={closeLabel}
      confirmLabel={confirmLabel}
      closeIcon={closeIcon}
      confirmIcon={confirmIcon}
      confirmDisabled={confirmDisabled}
      confirmLoading={confirmLoading}
      isSubmitType={isSubmitType}
    />
  );
};
